module.exports = __webpack_public_path__ + "static/media/volume.51d7aa4a.gif";